module.exports = __webpack_public_path__ + "img/magicMystic1.b1f49c7c.jpg";